import { render, staticRenderFns } from "./postManage.vue?vue&type=template&id=b60e2450&scoped=true&"
import script from "./postManage.vue?vue&type=script&lang=js&"
export * from "./postManage.vue?vue&type=script&lang=js&"
import style0 from "./postManage.vue?vue&type=style&index=0&id=b60e2450&prod&scoped=true&lang=css&"
import style1 from "./postManage.vue?vue&type=style&index=1&id=b60e2450&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60e2450",
  null
  
)

export default component.exports